<template>
  <div class="bootscreenshu-div">
    <!-- <div class="signbuttoncontent">
      <van-field v-model="cardNumber" placeholder="请输入卡号" />
      <van-button type="primary" @click="clickScanCard">签到</van-button>
    </div> -->
    <div class="bootscreenshu-info">
      <div class="info-left van-multi-ellipsis--l2">
        {{ currentAddress || "" }}
      </div>
      <div class="info-right">
        <div class="info-time">{{ timeString }}</div>
        <div class="info-date">{{ dateString }}</div>
      </div>
    </div>
    <div class="bootscreenshu-top">
      <img
        class="top-logo"
        v-if="headerLogo && headerLogo.length > 0"
        :src="headerLogo | imgFormat"
        alt=""
      />
      <div class="top-logo" v-else></div>
    </div>
    <div class="bootscreenshu-bgdiv">
      <div v-if="bottomButtonArr.length > 0" class="bootscreenshu-tabdiv">
        <div
          v-for="(item, index) in bottomButtonArr"
          :key="'tabdiv-item' + index"
          :class="selectIndex == index ? 'tabdiv-item-select' : 'tabdiv-item'"
          @click="selectTabButton(index)"
        >
          {{ item }}
        </div>
      </div>
      <div v-else class="bootscreenshu-tabdiv"></div>
      <div class="bootscreenshu-paddingdiv">
        <div class="bootscreenshu-maindiv">
          <div class="bootscreenshu-content" v-if="bottomButtonArr.length > 0">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="show"
      :show-confirm-button="false"
      closeOnClickOverlay
      :show-cancel-button="false"
      width="85%"
    >
      <div class="dialog-signin-maindiv" @click="show = false">
        <div class="dialog-closebuttondiv">点击任意处关闭</div>
        <div
          class="dialog-closebutton iconfont icon-icon_wrong"
          @click="show = false"
        ></div>
        <div class="dialog-maininfo">
          <div class="maininfo_mess">
            <div class="maininfo_mess_imgcontent">
              <img
                src="../../../public/img/product/bootScreen/icon-alert.png"
              />
            </div>
            <p class="go_place">
              {{ attendInfo.name || "" }}学员<br />请您前往<span>{{
                addressInfo.place || ""
              }}</span
              >签到！
            </p>
            <p class="now_place">当前位置：{{ currentAddress || "" }}</p>
          </div>
          <div class="course_mess">
            <p class="course_title">您的课程信息如下：</p>
            <div class="course_item">
              <p class="course_label iconfont icon-rili"></p>
              <p class="course_val">
                {{
                  dsf.date.format(addressInfo.beginDateTime, "mm月dd日 hh:ii")
                }}
              </p>
            </div>
            <div class="course_item">
              <p class="course_label iconfont icon-address"></p>
              <p class="course_val">{{ addressInfo.place || "" }}</p>
            </div>
            <div class="course_item">
              <p class="course_label iconfont icon-xxkc"></p>
              <p class="course_val">
                {{ addressInfo.name || "" }}
              </p>
            </div>
            <div class="course_item">
              <p class="course_label iconfont icon-jiaoshi"></p>
              <p class="course_val">{{ addressInfo.speakerText || "" }}</p>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerLogo: dsf.config.setting_screen_vertical_top_picture,
      weekArr: [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      timeString: "",
      dateString: "",
      timer: null,
      bottomButtonArr: [],
      bottomButtonPath: [],
      selectIndex: 0,
      show: false,
      addressInfo: {},
      currentAddress: "",
      attendInfo: {},
      errorAddressTimer: null,
      cardNumber:"",
    };
  },
  beforeRouteUpdate(to, from, next) {
    window.swipingCardFunction = this.swipingCardFunction;
    next();
  },
  mounted() {
    this.settingPageFunction();
    window.swipingCardFunction = this.swipingCardFunction;
    this.checkPageStatus();
    this.timer = setInterval(() => {
      this.updateTime();
      this.autoOpenSignInPage();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.errorAddressTimer) {
      clearTimeout(this.errorAddressTimer);
    }
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      this.checkPageStatus();
    },
  },
  methods: {
    settingPageFunction() {
      let tempString = sessionStorage.getItem("deviceInfo");
      if (tempString && tempString.length > 0) {
        let tempDeviceData = JSON.parse(tempString);
        let tempArray = tempDeviceData.verticalReleaseTypeList || [];
        let tempBottomButtonArr = [];
        let tempBottomButtonPath = [];
        tempArray.forEach((item) => {
          tempBottomButtonArr.push(item.moduleName);
          switch (parseInt(item.moduleId)) {
            case 1: {
              tempBottomButtonPath.push("schoolIntroduction");
              break;
            }
            case 2: {
              tempBottomButtonPath.push("campusDynamic");
              break;
            }
            case 3: {
              tempBottomButtonPath.push("announcements");
              break;
            }
            case 4: {
              tempBottomButtonPath.push("curriculumClasses");
              break;
            }
            case 5: {
              tempBottomButtonPath.push("courseArrangement");
              break;
            }
            default:
              break;
          }
        });
        this.bottomButtonArr = tempBottomButtonArr;
        this.bottomButtonPath = tempBottomButtonPath;
        this.currentAddress = tempDeviceData.classroomText || "";
      }
    },
    formatTime(num, digit) {
      let zero = "";
      for (let i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    updateTime() {
      let nowDate = new Date();
      this.timeString =
        this.formatTime(nowDate.getHours(), 2) +
        ":" +
        this.formatTime(nowDate.getMinutes(), 2);
      this.dateString =
        nowDate.getFullYear() +
        "年" +
        (nowDate.getMonth() + 1) +
        "月" +
        nowDate.getDate() +
        "日" +
        " " +
        this.weekArr[nowDate.getDay()];
    },
    selectTabButton(index) {
      this.selectIndex = index;
      this.$router.push({
        path: "/mobile/bootScreen/longitudinal/" + this.bottomButtonPath[index],
      });
    },
    checkPageStatus() {
      let path = this.$route.path || "";
      this.bottomButtonPath.forEach((item, index) => {
        if (path.indexOf(item) > -1) {
          this.selectIndex = index;
          return;
        }
      });
    },
    autoOpenSignInPage() {
      let tempSecond = new Date().getSeconds();
      if (tempSecond == 3) {
        let _this = this;
        this.$http
          .get(
            "/teas/screen/pollingCurrentClassroomArrangement",
            {
              equipmentId: sessionStorage.getItem("equipmentId") || "",
            },
            {},
            $$webRoot.default
          )
          .done(({ success, data, message }) => {
            if (success) {
              let tempData = data || {};
              if (!dsf.isEmptyObject(tempData)) {
                let tempArrayString =
                  sessionStorage.getItem("autoJumpList") || "";
                if (tempArrayString.length > 0) {
                  let tempArray = JSON.parse(tempArrayString);
                  if (
                    tempData.id &&
                    tempData.id.length > 0 &&
                    tempArray.indexOf(tempData.id) == -1
                  ) {
                    tempArray.push(tempData.id);
                    sessionStorage.setItem(
                      "autoJumpList",
                      JSON.stringify(tempArray)
                    );
                    var url =
                      "/mobile/bootScreen/attendance?id=" +
                      tempData["id"] +
                      "&relId=" +
                      tempData["relId"] +
                      "&courseNoonId=" +
                      tempData["courseNoonId"] +
                      "&type=" +
                      tempData["typeValue"] +
                      "&attendMode=" +
                      tempData["courseAttendMode"];
                    _this.$router.push({
                      path: url,
                    });
                  }
                } else {
                  let tempArray = [];
                  tempArray.push(tempData.id);
                  sessionStorage.setItem(
                    "autoJumpList",
                    JSON.stringify(tempArray)
                  );
                  var url =
                    "/mobile/bootScreen/attendance?id=" +
                    tempData["id"] +
                    "&relId=" +
                    tempData["relId"] +
                    "&courseNoonId=" +
                    tempData["courseNoonId"] +
                    "&type=" +
                    tempData["typeValue"] +
                    "&attendMode=" +
                    tempData["courseAttendMode"];
                  _this.$router.push({
                    path: url,
                  });
                }
              }
            } else {
              dsf.layer.message(message, false);
            }
          })
          .error((err) => {
            dsf.layer.message(err.message || "请求异常", false);
          });
      }
    },
    //刷卡调用方法
    swipingCardFunction(cardId, faceInfo) {
      let _this = this;
      this.$http
        .post(
          "/teas/screen/payByCard",
          {
            cardId: cardId || "",
            faceInfo: faceInfo || "",
            equipmentId: sessionStorage.getItem("equipmentId") || "",
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            if (_this.show) {
              _this.show = false;
            }
            if (_this.errorAddressTimer) {
              clearTimeout(_this.errorAddressTimer);
            }
            let code =
              data.signMessage && data.signMessage.errorCode
                ? data.signMessage.errorCode
                : 0;
            switch (code) {
              case 30004: {
                _this.addressInfo = data.jumpArrange || {};
                _this.attendInfo = data.signMessage || {};
                _this.show = true;
                let tempThis = _this;
                _this.errorAddressTimer = setTimeout(() => {
                  tempThis.show = false;
                }, 10000);
                break;
              }
              case 30005: {
                dsf.layer.message(data.signMessage.errorText || "", false);
                break;
              }
              case 30007: {
                //跳转课程
                let tempObject = data.currentArrange || {};
                _this.jumpNextPage(tempObject, cardId, faceInfo);
                break;
              }
              default:
                break;
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    jumpNextPage(dataObject, cardId, faceInfo) {
      var url =
        "/mobile/bootScreen/attendance?id=" +
        dataObject["id"] +
        "&relId=" +
        dataObject["relId"] +
        "&courseNoonId=" +
        dataObject["courseNoonId"] +
        "&type=" +
        dataObject["typeValue"] +
        "&attendMode=" +
        dataObject["courseAttendMode"] +
        "&cardId=" +
        cardId +
        "&faceInfo=" +
        faceInfo +
        "&needSignIn=1";
      this.$router.push({
        path: url,
      });
    },
    clickScanCard(){
      window.swipingCardFunction(this.cardNumber , "");
    }
  },
};
</script>

<style>
.signbuttoncontent{
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  z-index: 9999;
}
</style>